import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./css/KitchenReg.css";
import 'bootstrap/dist/css/bootstrap.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import { ToastContainer, toast } from 'react-toastify';
import edit from './images/MenuReg/Editing1.png'
import tick from './images/icons/check.png'
import cross from './images/icons/cross.png'
import { DBContext } from './DBContext'
import axios from 'axios'

function Discount() {

    const [DiscountName, setDiscountName] = useState("");
    const [DiscountPercent, setDiscountPercent] = useState("");
    const [SDate, setSDate] = useState("");
    const [EDate, setEDate] = useState("");
    const location = useLocation(null)

    const [discountId,setDiscountId] = useState(null)
    const [discount,setDiscount] = useState(null)

    useEffect(() => {
        if (location.state) {
            setDiscountId(location.state.id)
            setDiscount(location.state.discount)
        }
    },[location])

    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { logginedDB , user_Id } = useContext(DBContext);
    
    const handleSubmit = async () => {

        // if (!DiscountName || !DiscountPercent) {
        //     alert("Please fill the required fields.");
        //     return;
        // }

        if ( !DiscountName  || !DiscountPercent) {
            return alert("Please fill the required fields.");
        }
        if (!SDate || !EDate || SDate >= EDate) {
            return alert("Please Check Start date and End data")
        }

        const data = {
            DiscountName: DiscountName,
            DiscountPercent: DiscountPercent,
            SDate: SDate,
            EDate: EDate
        };

        const currentDate = new Date().toISOString().split('T')[0];

        const formatTime = () => {
            let now = new Date();
            let hours = now.getHours();
            let minutes = now.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
            minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes
            return `${hours}:${minutes} ${ampm}`;
        };

        const eventDetails = {
            ddate: currentDate,
            ttime: formatTime(),
            user_Id: user_Id, // Replace with actual user ID variable
            // user: userName // Replace with actual user variable
        };

        let response;

        try {
            //("Try");
            if (discountId) {
                response = await fetch(`${api_base_url}/DiscountRegUpdate/${discountId}/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            } else {
                response = await fetch(`${api_base_url}/DiscountReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            }

            if (response.ok) {
                toast.success("Discount successully Registered",{
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => {}
                });
                // Optionally, reset the form fields here
                setDiscountName("");
                setDiscountPercent("");
                navigate('/basemenureg', {
                    state: 'DiscountCancel'
                })
                
            } else {
                toast.error("Discount Registered/Edit Failed. Please try again.",{
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => {}
                });
                console.error("Failed to submit data");
            }

        } catch (error) {
            toast.error("Kitchen Registered Failed. Please try again.",{
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => {}
            });
            console.error("Error:", error);
        }
        
    }
    
    const handleDiscountNameChange = (event) => {
        const val = event.target.value
        setDiscountName(val);
    };

    const handleDiscPercentChange = (event) => {
        const val = event.target.value
        setDiscountPercent(val);
    };

    const handleSDateChange = (event) => {
        const val = event.target.value
        setSDate(val);
    };

    const handleEDateChange = (event) => {
        const val = event.target.value
        setEDate(val);
    };

    const handleModifyDiscount = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getDiscountDetails/${discountId}/${logginedDB}`)
            if (response.status == 200) {
                setDiscountName(response.data[0].d_name)
                setDiscountPercent(response.data[0].d_Prctg)
                setSDate(response.data[0].d_sDate.split('T')[0]);
                setEDate(response.data[0].d__eDate.split('T')[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (discountId) {
            handleModifyDiscount()
        }
    },[discountId])
    
    // useEffect(() => {
    //     const handleWindowResize = () => {
    //         if (window.innerWidth <= 768) {
    //             setCollapsed(true);
    //         } else {
    //             setCollapsed(false);
    //         }
    //     };

    //     window.addEventListener("resize", handleWindowResize);

    //     return () => {
    //         window.removeEventListener("resize", handleWindowResize);
    //     };
    // }, []);


    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/basemenureg', {
            state: 'DiscountCancel'
        })
    }

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    return (
        <div className='KitchenRegMainDiv'>
            <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
            <div className='KitchenRegContentDiv flex gap-3'>
                <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                <div className='KitchenRegContentSideBarRight'>
                    <div className="KitchenRegSidebar">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Discount'} />
                    </div>
                    <div className='Container_Menu KitchenRegForm flex flex-col h-full pt-3'>
                        <div className='TableAreaReg_areaDetails_span bg-white rounded-t-md border-b'>
                            <span>{discount ? discount : 'Discount Details'}</span>
                            <div className=' AddItem_Buttons AddItem_Buttons_TableAreaReg text-nowrap'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                        {/* <div className='KitchenRegForm_Contents '> */}
                        <div className='w-full flex flex-col gap-4 p-4 bg-white flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200'>
                            <div className='w-full flex gap-3'>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>Discount Name</span>
                                    {/* <input className="KitchenName p-2" type="text" value={KitchenName} onChange={handleKitchenNameChange} /> */}
                                    <div className='w-full flex areaBorder h-[2.5rem] rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 p-2' type="text" 
                                        value={DiscountName}
                                        onChange={handleDiscountNameChange}/>
                                    </div>
                                </div>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>Disc %</span>
                                    {/* <input className="KitchenCode p-2" type="text" value={KitchenCode} onChange={handleKitchenCodeChange} 
                                    disabled={codeDisable}/> */}
                                    <div className='w-full flex h-[2.5rem] areaBorder rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 KitchenCode p-2' type="number" 
                                        value={DiscountPercent || ''}
                                        onChange={handleDiscPercentChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex gap-3'>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>SDate</span>
                                    <div className='w-full flex areaBorder h-[2.5rem] rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 p-2' type="date" 
                                        value={SDate}
                                        onChange={handleSDateChange}/>
                                    </div>
                                </div>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>EDate</span>
                                    <div className='w-full flex areaBorder h-[2.5rem] rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 p-2' type="date" 
                                        value={EDate}
                                        onChange={handleEDateChange}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Discount
